import React from 'react';

import { AttentionCircleFilledIcon } from '@vlabs/icons';
import validate from '@vlabs/shared/validators';
import { Control } from '@vlabs/uikit';

import st from './inputs.module.sass';
import { useSearchPageTranslation } from '../../../i18n';

export interface EventInputProps {
  inputError: string;
  inputValue: string;
  onInputChange: (v: string | undefined, {
    validationError,
    debounced,
  }: {
    validationError?: string | undefined;
    debounced?: boolean;
  }) => void;
  resetInput: () => void;
}

export function EventInput({
  inputError, inputValue, onInputChange, resetInput,
}: EventInputProps): JSX.Element {
  const { t } = useSearchPageTranslation();

  return (
    <React.Fragment>
      <Control.Input
        className={st.EventIdInput}
        data-testid="eventId"
        hasError={!!inputError}
        id="eventId"
        isClearable
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onInputChange(e?.target?.value, {
          validationError: validate.uuid()(e?.target?.value),
        })}
        onClear={resetInput}
        placeholder={t('reference_selector.event_id_input.placeholder')}
        value={inputValue}
      />
      {
        !!inputError
        && (
          <div className={st.InputError}>
            <AttentionCircleFilledIcon />
            {inputError}
          </div>
        )
      }
    </React.Fragment>
  );
}
